import React, { useEffect, useState } from "react";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import DatePicker from "react-datepicker"; // Correct import
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker-custom.css";
import "./datepicker-custom.css";
import Button from "../ui/Button";
import useClickOutside from "@/hooks/useClickOutSide";
import moment from "moment";

interface Option {
  label: string;
  value: string;
}

interface SelectCustomDateProps {
  options: Option[];
  placeholder: string;
  onChange: (value: any) => void;
  selectedValue: Option;
}

const SelectCustomDate: React.FC<SelectCustomDateProps> = ({ options, placeholder, onChange, selectedValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCustomDateOpen, setIsCustomDateOpen] = useState(false);
  const [currentOption, setCurrentOption] = useState<string | null>(null);
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [dateError, setDateError] = useState<string>("");
  const dropdownRef = useClickOutside(() => setIsOpen(false));
  const datePickerRef = useClickOutside(() => setIsCustomDateOpen(false));

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelectOption = (value: Option) => {
    setCurrentOption(value.value);
    if (value.value === "customPeriod") {
      setIsCustomDateOpen(true);
    } else {
      onChange(value);
    }
    setIsOpen(false);
  };

  const handleSaveDates = () => {
    setDateError("");
    if (fromDate && toDate) {
      if (fromDate > toDate) {
        setDateError("From date cannot be after To date.");
        return;
      }
      onChange({
        label: `From ${moment(fromDate).format("DD MMM YYYY")} to ${moment(toDate).format("DD MMM YYYY")}`,
        value: "customPeriod",
        fromDate: moment(fromDate).format("YYYY-MM-DD"),
        toDate: moment(toDate).format("YYYY-MM-DD"),
      });
      setIsCustomDateOpen(false);
    }
  };
  useEffect(() => {
    if (!isCustomDateOpen && currentOption !== "customPeriod") {
      setFromDate(null);
      setToDate(null);
    }
  }, [isCustomDateOpen, currentOption]);

  return (
    <div className="relative text-13 text-text-primary w-fit !z-20 ">
      <button className="p-2 rounded-md flex items-center focus:outline-none focus:ring-0" onClick={handleToggleDropdown}>
        <span>{selectedValue.label || placeholder}</span>
        {isOpen ? <MdArrowDropUp className="text-text-primary" size={24} /> : <MdArrowDropDown className="text-text-primary" size={24} />}
      </button>

      {isOpen && (
        <div className="absolute mt-1 w-fit bg-white border rounded-md shadow-lg whitespace-nowrap" ref={dropdownRef}>
          <ul className="flex flex-col">
            {options.map((option) => (
              <li key={option.value} className="px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => handleSelectOption(option)}>
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}

      {isCustomDateOpen && (
        <>
          {/* Mobile overlay */}
          <div className="hidden max-md:block fixed inset-0 bg-black bg-opacity-50 z-40"></div>

          <div
            className={`absolute bg-white  border border-gray-200 shadow-2xl rounded-xl p-3 md:p-4 mt-2 flex flex-col items-center gap-2 md:gap-4 transition-all duration-300 z-50 
              max-md:fixed max-md:inset-5 max-md:w-fit max-md:h-fit max-md:mt-0 max-md:top-1/2 max-md:left-1/2 max-md:-translate-x-1/2 max-md:-translate-y-1/2`}
            ref={datePickerRef}
          >
            <div className="flex flex-col w-full gap-2">
              <label className="text-sm font-medium text-gray-700 mb-1">From</label>
              <DatePicker
                selected={fromDate}
                onChange={(date: Date | null) => setFromDate(date)}
                selectsStart
                startDate={fromDate}
                endDate={toDate}
                dateFormat="dd MMM yyyy"
                className="p-2 border border-gray-300 rounded-lg focus:outline-none  focus:border-text-primary w-64 transition-all duration-300"
                maxDate={toDate || undefined}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Select start date"
                onKeyDown={(e) => e.preventDefault()}
                autoComplete="off"
                onFocus={(e) => {
                  e.target.blur();
                  e.target.click();
                }}
              />
            </div>
            <div className="flex flex-col w-full gap-2">
              <label className="text-sm font-medium text-gray-700 mb-1">To</label>
              <DatePicker
                selected={toDate}
                onChange={(date: Date | null) => setToDate(date)}
                selectsEnd
                startDate={fromDate}
                endDate={toDate}
                dateFormat="dd MMM yyyy"
                className="p-2 border border-gray-300 rounded-lg focus:outline-none  focus:border-text-primary w-64 transition-all duration-300"
                minDate={fromDate || undefined}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Select end date"
                onKeyDown={(e) => e.preventDefault()}
                autoComplete="off"
                onFocus={(e) => {
                  e.target.blur();
                  e.target.click();
                }}
              />
            </div>
            {dateError && <div className="text-red-500 text-xs mt-1 mb-1 w-full text-center">{dateError}</div>}
            <div className="flex justify-end w-full gap-2 mt-2">
              <Button variant="outline" size="small" onClick={() => setIsCustomDateOpen(false)}>
                Cancel
              </Button>
              <Button variant="primary" size="small" onClick={handleSaveDates}>
                Save
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SelectCustomDate;
